var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 482.55,
    height: 493.11,
    viewBox: "0 0 482.55 493.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1, .cls-2 {\n            fill: #68cdef;\n            }\n\n            .cls-3 {\n            fill: #384443;\n            }\n\n            .cls-4 {\n            fill: none;\n            stroke: #231f20;\n            stroke-miterlimit: 22.93;\n            stroke-width: .57px;\n            }\n\n            .cls-2 {\n            fill-rule: evenodd;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.81,144.23c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 126.77,
    cy: 71.41,
    rx: 7.51,
    ry: 7.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 126.77,
    cy: 71.41,
    rx: 7.51,
    ry: 7.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.93,102.71c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.19,66.36c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.03,35.5c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.33,13.8c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.12,.91c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.52,0c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.38,11.29c4.7,0,8.51,3.83,8.51,8.55s-3.81,8.55-8.51,8.55-8.51-3.83-8.51-8.55,3.81-8.55,8.51-8.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.95,31.22c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.11,61.4c5.71,0,10.33,4.65,10.33,10.38s-4.63,10.38-10.33,10.38-10.33-4.65-10.33-10.38,4.63-10.38,10.33-10.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.62,97.13c6.04,0,10.94,4.92,10.94,10.99s-4.9,10.99-10.94,10.99-10.94-4.92-10.94-10.99,4.9-10.99,10.94-10.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.86,135.44c6.71,0,12.16,5.47,12.16,12.21s-5.44,12.21-12.16,12.21-12.16-5.47-12.16-12.21,5.44-12.21,12.16-12.21"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 126.95,
    cy: 223.74,
    rx: 7.51,
    ry: 7.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 126.95,
    cy: 223.74,
    rx: 7.51,
    ry: 7.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.11,192.44c2.01,0,3.65-1.64,3.65-3.66s-1.63-3.66-3.65-3.66-3.65,1.64-3.65,3.66,1.63,3.66,3.65,3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.37,228.79c2.35,0,4.26-1.91,4.26-4.27s-1.91-4.27-4.26-4.27-4.26,1.91-4.26,4.27,1.91,4.27,4.26,4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.21,259.65c2.69,0,4.86-2.19,4.86-4.89s-2.18-4.89-4.86-4.89-4.86,2.19-4.86,4.89,2.18,4.89,4.86,4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.51,281.35c3.02,0,5.47-2.46,5.47-5.5s-2.45-5.5-5.47-5.5-5.47,2.46-5.47,5.5,2.45,5.5,5.47,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.29,294.24c4.03,0,7.29-3.28,7.29-7.33s-3.27-7.33-7.29-7.33-7.29,3.28-7.29,7.33,3.27,7.33,7.29,7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.7,295.15c4.36,0,7.9-3.55,7.9-7.94s-3.54-7.94-7.9-7.94-7.9,3.55-7.9,7.94,3.54,7.94,7.9,7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.55,283.86c4.7,0,8.51-3.83,8.51-8.55s-3.81-8.55-8.51-8.55-8.51,3.83-8.51,8.55,3.81,8.55,8.51,8.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.13,263.94c5.37,0,9.73-4.37,9.73-9.77s-4.35-9.77-9.73-9.77-9.73,4.37-9.73,9.77,4.35,9.77,9.73,9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.29,233.75c5.71,0,10.33-4.65,10.33-10.38s-4.63-10.38-10.33-10.38-10.33,4.65-10.33,10.38,4.63,10.38,10.33,10.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.79,198.02c6.04,0,10.94-4.92,10.94-10.99s-4.9-10.99-10.94-10.99-10.94,4.92-10.94,10.99,4.9,10.99,10.94,10.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.8,143.39c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.82,167.96c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M325.76,142.87c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.96,104.58c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356,92.87c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.68,129.89c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.4,121.13c1.68,0,3.04,1.37,3.04,3.05s-1.36,3.05-3.04,3.05-3.04-1.37-3.04-3.05,1.36-3.05,3.04-3.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.66,124.64c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.6,112.41c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.17,98.49c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.98,82.04c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.68,63.05c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.18,173.57c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.1,155.86c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.88,188.76c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.85,65.58c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.42,85.41c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.63,82.46c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M334.45,201.84c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.05,204.79c2.01,0,3.65,1.64,3.65,3.66s-1.63,3.66-3.65,3.66-3.65-1.64-3.65-3.66,1.63-3.66,3.65-3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.08,158.62c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.12,180.56c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.81,38.82c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.85,61.6c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.73,69.61c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.33,54.01c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.08,216.83c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.48,222.74c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.85,224.43c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.79,202.49c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.9,62.86c2.35,0,4.26,1.91,4.26,4.27s-1.91,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.72,50.69c2.35,0,4.26,1.91,4.26,4.27s-1.9,4.27-4.26,4.27-4.26-1.91-4.26-4.27,1.91-4.27,4.26-4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.81,45.38c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.88-4.86,4.88-4.86-2.19-4.86-4.88,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.73,23.87c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.1,53.4c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.22,62.68c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.88-4.86,4.88-4.86-2.19-4.86-4.88,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M356.42,191.33c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.59,221.28c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.53,219.6c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.65,239.84c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.82,221.7c2.69,0,4.86,2.19,4.86,4.89s-2.18,4.89-4.86,4.89-4.86-2.19-4.86-4.89,2.18-4.89,4.86-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.55,36.16c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.72,19.04c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.39,68.39c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.75,64.17c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.17,229.53c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.5,247.14c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.37,214.77c3.02,0,5.47,2.46,5.47,5.5s-2.45,5.5-5.47,5.5-5.47-2.46-5.47-5.5,2.45-5.5,5.47-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.44,33.66c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.29,23.11c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311.91,242.04c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.99,255.12c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.14,232.34c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.52,228.12c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.86,246c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.89,42.94c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.49,78.37c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.98,260.84c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.89,236.37c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.59,216.54c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.55,162.13c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.19,138.5c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.44,126.27c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.54,81.98c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.34,60.47c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.37,36.42c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.85,58.78c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.85,79.22c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.79,96.09c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.57,102.42c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.71,117.18c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.79,182.99c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.33,199.02c4.03,0,7.29,3.28,7.29,7.33s-3.27,7.33-7.29,7.33-7.29-3.28-7.29-7.33,3.27-7.33,7.29-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.7,87.32c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.46,121.07c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.64,107.87c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.74,137.94c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.46,155.66c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.55,254.36c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.47,239.18c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.91,217.24c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.82,187.57c6.04,0,10.94,4.92,10.94,10.99s-4.9,10.99-10.94,10.99-10.94-4.92-10.94-10.99,4.9-10.99,10.94-10.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.44,153.27c4.36,0,7.9,3.55,7.9,7.94s-3.54,7.94-7.9,7.94-7.9-3.55-7.9-7.94,3.54-7.94,7.9-7.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.94,167.89c5.37,0,9.73,4.37,9.73,9.77s-4.35,9.77-9.73,9.77-9.73-4.37-9.73-9.77,4.35-9.77,9.73-9.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.29,176.95c4.7,0,8.51,3.83,8.51,8.55s-3.81,8.55-8.51,8.55-8.51-3.83-8.51-8.55,3.81-8.55,8.51-8.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.96,196.11c4.7,0,8.51,3.83,8.51,8.55s-3.81,8.55-8.51,8.55-8.51-3.83-8.51-8.55,3.81-8.55,8.51-8.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.85,219.31c4.7,0,8.51,3.83,8.51,8.55s-3.81,8.55-8.51,8.55-8.51-3.83-8.51-8.55,3.81-8.55,8.51-8.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.27,199.06c4.7,0,8.51,3.83,8.51,8.55s-3.81,8.55-8.51,8.55-8.51-3.83-8.51-8.55,3.81-8.55,8.51-8.55"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.4,438.23h-19.66L1.85,320.12H23.02l37.47,95.6,37.64-95.6h21l-48.72,118.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.79,437.73h-86.86v-117.61h86.36v18.31h-67.54v31.75h64.85v17.47h-64.85v31.59h68.05v18.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M332.17,347.17c-4.03-4.03-8.93-7.14-14.7-9.32s-11.45-3.28-17.05-3.28c-13.33,0-23.91,4.37-31.75,13.11-7.84,8.74-11.7,19.55-11.59,32.43,0,11.87,3.64,21.9,10.92,30.07,7.28,8.18,18.09,12.26,32.43,12.26,10.87,0,20.44-3.47,28.73-10.42v-23.86h-32.76v-16.8h50.24v48.22c-12.43,13.67-27.83,20.5-46.2,20.5-10.42,0-19.69-1.65-27.81-4.96-8.12-3.3-14.59-7.78-19.41-13.44-4.82-5.66-8.46-11.98-10.92-18.99-2.46-7-3.7-14.53-3.7-22.6,0-17.81,5.49-32.73,16.47-44.78,10.98-12.04,26.1-18.06,45.36-18.06,17.03,0,31.53,5.94,43.52,17.81l-11.76,12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M449.79,413.03h-63.68l-11.09,24.7h-19.99l52.76-117.61h20.5l52.76,117.61h-19.99l-11.26-24.7Zm-31.75-73.09l-24.87,55.95h49.73l-24.87-55.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.25,485c-1.87,0-3.6-.3-5.19-.88-1.59-.59-2.97-1.43-4.14-2.52-1.17-1.09-2.07-2.38-2.72-3.87-.65-1.49-.97-3.14-.97-4.94s.32-3.45,.97-4.94c.64-1.49,1.55-2.78,2.72-3.87,1.17-1.09,2.55-1.93,4.14-2.52,1.59-.59,3.32-.88,5.19-.88,2.29,0,4.32,.4,6.09,1.2,1.77,.8,3.23,1.96,4.39,3.47l-4.97,4.44c-.69-.87-1.45-1.54-2.28-2.02-.83-.48-1.77-.72-2.82-.72-.82,0-1.57,.13-2.23,.4-.67,.27-1.24,.66-1.72,1.17-.48,.51-.85,1.13-1.12,1.85-.27,.72-.4,1.53-.4,2.42s.13,1.7,.4,2.42c.27,.72,.64,1.34,1.12,1.85,.48,.51,1.05,.9,1.72,1.17,.67,.27,1.41,.4,2.23,.4,1.04,0,1.98-.24,2.82-.72,.83-.48,1.6-1.15,2.28-2.02l4.97,4.44c-1.16,1.49-2.62,2.64-4.39,3.45-1.77,.81-3.8,1.22-6.09,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.86,484.47h-7.87v-23.35h7.87v23.35Zm7.8-8.61h-8.34v-6.47h8.34v6.47Zm-.53-14.75h7.87v23.35h-7.87v-23.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.27,484.47l10.21-23.35h7.74l10.21,23.35h-8.14l-7.54-19.62h3.07l-7.54,19.62h-8Zm6.07-4.07l2-5.67h10.74l2,5.67h-14.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.93,485c-1.89,0-3.64-.3-5.25-.9-1.61-.6-3.01-1.45-4.19-2.55-1.18-1.1-2.1-2.4-2.75-3.89-.66-1.49-.98-3.11-.98-4.87s.33-3.41,.98-4.89c.66-1.48,1.57-2.77,2.75-3.87,1.18-1.1,2.57-1.95,4.19-2.55,1.61-.6,3.36-.9,5.25-.9s3.67,.3,5.27,.9c1.6,.6,2.99,1.45,4.17,2.55,1.18,1.1,2.1,2.39,2.75,3.87,.66,1.48,.98,3.11,.98,4.89s-.33,3.38-.98,4.87c-.66,1.49-1.57,2.79-2.75,3.89-1.18,1.1-2.57,1.95-4.17,2.55-1.6,.6-3.36,.9-5.27,.9Zm0-6.37c.73,0,1.42-.13,2.05-.4,.63-.27,1.19-.65,1.67-1.15,.48-.5,.85-1.11,1.12-1.83,.27-.72,.4-1.54,.4-2.45s-.13-1.73-.4-2.45c-.27-.72-.64-1.33-1.12-1.83-.48-.5-1.03-.88-1.67-1.15-.63-.27-1.32-.4-2.05-.4s-1.42,.13-2.05,.4-1.19,.65-1.67,1.15c-.48,.5-.85,1.11-1.12,1.83-.27,.72-.4,1.54-.4,2.45s.13,1.73,.4,2.45c.27,.72,.64,1.33,1.12,1.83,.48,.5,1.03,.88,1.67,1.15,.63,.27,1.32,.4,2.05,.4Zm7.64,11.74c-1.09,0-2.1-.11-3.04-.32-.93-.21-1.84-.56-2.72-1.05s-1.8-1.16-2.75-2.02c-.96-.86-2.02-1.92-3.2-3.19l8.14-2c.53,.82,.99,1.46,1.37,1.9,.38,.45,.75,.76,1.12,.93s.78,.27,1.25,.27c1.16,0,2.23-.5,3.24-1.5l3.4,4c-1.67,1.98-3.94,2.97-6.8,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.15,485c-3.58,0-6.37-.97-8.37-2.9-2-1.93-3-4.65-3-8.14v-12.84h7.87v12.61c0,1.78,.32,3.04,.97,3.79,.64,.75,1.51,1.12,2.6,1.12s1.98-.37,2.62-1.12c.63-.75,.95-2.01,.95-3.79v-12.61h7.74v12.84c0,3.49-1,6.21-3,8.14-2,1.94-4.79,2.9-8.37,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M211.86,478.53h11.67v5.94h-19.41v-23.35h18.98v5.94h-11.24v11.48Zm-.53-8.74h10.41v5.67h-10.41v-5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.64,484.47v-17.25h-6.84v-6.11h21.55v6.11h-6.84v17.25h-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M245.84,484.47l10.21-23.35h7.74l10.21,23.35h-8.14l-7.54-19.62h3.07l-7.54,19.62h-8Zm6.07-4.07l2-5.67h10.74l2,5.67h-14.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.97,485c-1.96,0-3.85-.22-5.67-.67-1.82-.44-3.32-1.02-4.5-1.73l2.54-5.74c1.11,.64,2.35,1.16,3.72,1.55,1.37,.39,2.7,.58,3.99,.58,.76,0,1.35-.05,1.78-.15,.43-.1,.75-.24,.95-.43,.2-.19,.3-.42,.3-.68,0-.42-.23-.76-.7-1-.47-.24-1.08-.45-1.85-.62-.77-.17-1.61-.34-2.52-.53-.91-.19-1.83-.44-2.75-.75s-1.77-.72-2.54-1.23c-.77-.51-1.38-1.18-1.85-2.02s-.7-1.87-.7-3.12c0-1.45,.41-2.76,1.22-3.95,.81-1.19,2.02-2.14,3.64-2.85s3.62-1.07,6.02-1.07c1.58,0,3.13,.17,4.67,.5s2.91,.85,4.14,1.54l-2.37,5.71c-1.16-.58-2.27-1.01-3.35-1.3-1.08-.29-2.13-.43-3.15-.43-.76,0-1.36,.07-1.8,.2-.45,.13-.76,.31-.95,.53-.19,.22-.28,.47-.28,.73,0,.4,.23,.72,.7,.95,.47,.23,1.08,.43,1.85,.58,.77,.16,1.61,.32,2.54,.5,.92,.18,1.84,.42,2.75,.73s1.75,.72,2.52,1.23c.77,.51,1.38,1.18,1.85,2,.47,.82,.7,1.85,.7,3.07,0,1.42-.41,2.73-1.22,3.92-.81,1.19-2.02,2.15-3.62,2.87-1.6,.72-3.61,1.08-6.04,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.18,484.47v-23.35h11.24c2.18,0,4.06,.36,5.65,1.07s2.82,1.73,3.69,3.05,1.3,2.89,1.3,4.69-.43,3.36-1.3,4.67c-.87,1.31-2.1,2.33-3.69,3.05-1.59,.72-3.47,1.08-5.65,1.08h-6.87l3.5-3.37v9.11h-7.87Zm7.87-8.24l-3.5-3.57h6.37c1.09,0,1.9-.24,2.42-.73,.52-.49,.78-1.16,.78-2s-.26-1.51-.78-2-1.33-.73-2.42-.73h-6.37l3.5-3.57v12.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.96,484.47v-23.35h11.24c2.18,0,4.06,.36,5.65,1.07s2.82,1.73,3.69,3.05,1.3,2.89,1.3,4.69-.43,3.35-1.3,4.65c-.87,1.3-2.1,2.3-3.69,2.99s-3.47,1.03-5.65,1.03h-6.87l3.5-3.24v9.11h-7.87Zm7.87-8.24l-3.5-3.57h6.37c1.09,0,1.9-.24,2.42-.73,.52-.49,.78-1.16,.78-2s-.26-1.51-.78-2-1.33-.73-2.42-.73h-6.37l3.5-3.57v12.61Zm6.1,8.24l-5.74-8.51h8.34l5.8,8.51h-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.08,485c-1.91,0-3.67-.3-5.29-.9-1.61-.6-3.01-1.45-4.19-2.55-1.18-1.1-2.1-2.4-2.75-3.89-.66-1.49-.98-3.11-.98-4.87s.33-3.41,.98-4.89c.66-1.48,1.57-2.77,2.75-3.87,1.18-1.1,2.57-1.95,4.19-2.55,1.61-.6,3.36-.9,5.25-.9s3.67,.3,5.27,.9,2.99,1.45,4.17,2.55c1.18,1.1,2.1,2.39,2.75,3.87,.66,1.48,.98,3.11,.98,4.89s-.33,3.38-.98,4.87c-.66,1.49-1.57,2.79-2.75,3.89-1.18,1.1-2.57,1.95-4.17,2.55s-3.35,.9-5.24,.9Zm-.03-6.37c.73,0,1.42-.13,2.05-.4,.63-.27,1.19-.65,1.67-1.15,.48-.5,.85-1.11,1.12-1.83s.4-1.54,.4-2.45-.13-1.73-.4-2.45-.64-1.33-1.12-1.83c-.48-.5-1.03-.88-1.67-1.15s-1.32-.4-2.05-.4-1.42,.13-2.05,.4c-.63,.27-1.19,.65-1.67,1.15-.48,.5-.85,1.11-1.12,1.83-.27,.72-.4,1.54-.4,2.45s.13,1.73,.4,2.45c.27,.72,.64,1.33,1.12,1.83,.48,.5,1.03,.88,1.67,1.15,.63,.27,1.32,.4,2.05,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M385.09,484.47v-23.35h6.47l9.34,15.25h-3.4l9.07-15.25h6.47l.07,23.35h-7.17l-.07-12.54h1.13l-6.2,10.44h-3.47l-6.47-10.44h1.4v12.54h-7.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVega);
export default __webpack_public_path__ + "static/media/vega.859076a608df171d75dd46602a320710.svg";
export { ForwardRef as ReactComponent };